import InputCouponType from "components/input-coupon-type";
import { useOfmFiltersState } from "../../ducks/filter/hooks/state";
import { useOfmFiltersActions } from "../../ducks/filter/hooks/actions";

export default function SelectCoupon() {
  const { filters } = useOfmFiltersState();
  const { setCodInvoiceModel } = useOfmFiltersActions();

  const value = (filters?.codInvoiceModel as "55" | "65" | "Both" | undefined) ?? undefined;

  return (
    <InputCouponType
      label="Tipo da Nota"
      value={value}
      placeholder="Selecionar tipo (55/65)"
      onChange={(v?: string) => setCodInvoiceModel(v as any)}
    />
  );
}
